import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import MyNavbar from "../../../components/Customer/Mynavbar/MyNavbar";
import CategoryCircles from "../../../components/Customer/CategoryCircles/CategoryCircles";
import ProductCard from "../../../components/Customer/ProductCard/ProductCard";
import Footer from "../../../components/Customer/Footer/Footer";

import AppContext from "../../../context/AppContext";

import AccHero from "../../../subscreens/Accessories/SubScreens/AccHero/AccHero";
import AccCaro from "../../../subscreens/Accessories/SubScreens/AccCaro/AccCaro";

import "../../../assests/css/customer/Home/Home.css";

const Accessories = () => {
  const navigate = useNavigate();

  const {
    baseUrl,
    baseUrlForFiles,
    selectedCategory,
  } = useContext(AppContext);

  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  /*
  ==========================================================
  IMAGE URL FUNCTION
  ==========================================================
  */

  const getImageUrl = (imagePath) => {
    if (!imagePath) {
      return null;
    }

    let path = String(imagePath).trim();

    if (!path) {
      return null;
    }

    // Agar already complete URL hai
    if (
      path.startsWith("http://") ||
      path.startsWith("https://")
    ) {
      return path;
    }

    // Starting slash remove
    path = path.replace(/^\/+/, "");

    // storage/ ko duplicate hone se bachao
    if (path.startsWith("storage/")) {
      path = path.substring(8);
    }

    const base = String(baseUrlForFiles || "").replace(/\/+$/, "");

    if (!base) {
      return path;
    }

    return `${base}/${path}`;
  };

  /*
  ==========================================================
  FORMAT PRODUCT
  ==========================================================
  */

  const formatProduct = (product) => {
    const subTitle = (
      product?.subcategory?.title || ""
    )
      .toLowerCase()
      .replace(/[^a-z]/g, "");

    let type = "accessories";

    if (
      subTitle.includes("unstit") ||
      subTitle.includes("unstich")
    ) {
      type = "unstitched";
    }

    const images = Array.isArray(product?.images)
      ? product.images
          .map((img) => {
            if (typeof img === "string") {
              return getImageUrl(img);
            }

            return getImageUrl(
              img?.image_path ||
              img?.path ||
              img?.image
            );
          })
          .filter(Boolean)
      : [];

    return {
      ...product,
      images,
      price: product?.base_price,
      type,
    };
  };

  /*
  ==========================================================
  LOAD PRODUCTS
  ==========================================================
  */

  const loadProducts = async () => {
    if (!selectedCategory?.id) {
      console.log("No selected category found.");
      setAllProducts([]);
      return;
    }

    setLoading(true);

    try {
      console.log(
        "Selected Accessories Category:",
        selectedCategory
      );

      /*
      --------------------------------------------------------
      Pehle category ke tamam products load karo
      --------------------------------------------------------
      */

      const response = await axios.post(
        `${baseUrl}/customer/products/loadAllProductForCustomer`,
        {
          category_id: selectedCategory.id,
        }
      );

      const products = Array.isArray(
        response?.data?.products
      )
        ? response.data.products
        : [];

      console.log(
        "Accessories Products:",
        products
      );

      setAllProducts(products);
    } catch (error) {
      console.error(
        "Accessories products loading error:",
        error.response?.data || error
      );

      setAllProducts([]);
    } finally {
      setLoading(false);
    }
  };

  /*
  ==========================================================
  INITIAL LOAD
  ==========================================================
  */

  useEffect(() => {
    loadProducts();
  }, [selectedCategory?.id, baseUrl]);

  /*
  ==========================================================
  CATEGORY CIRCLE CLICK
  ==========================================================
  */

  const loadAllProductsWithCategory = async (
    categoryId,
    subcategoryId
  ) => {
    if (!subcategoryId) {
      return;
    }

    setLoading(true);

    try {
      console.log(
        "Clicked Category:",
        categoryId
      );

      console.log(
        "Clicked Subcategory:",
        subcategoryId
      );

      /*
      IMPORTANT:
      Yahan sirf subcategory_id bhej rahe hain.
      */

      const response = await axios.post(
        `${baseUrl}/customer/products/loadAllProductForCustomer`,
        {
          subcategory_id: subcategoryId,
        }
      );

      const products = Array.isArray(
        response?.data?.products
      )
        ? response.data.products
        : [];

      console.log(
        "Clicked Subcategory Products:",
        products
      );

      setAllProducts(products);
    } catch (error) {
      console.error(
        "Subcategory products error:",
        error.response?.data || error
      );

      setAllProducts([]);
    } finally {
      setLoading(false);
    }
  };

  /*
  ==========================================================
  WISHLIST
  ==========================================================
  */

  const toggleWishlist = (id) => {
    setWishlist((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  /*
  ==========================================================
  CART
  ==========================================================
  */

  const toggleCart = (id) => {
    setCart((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  /*
  ==========================================================
  RENDER
  ==========================================================
  */

  return (
    <div>
      <MyNavbar />

      <br />

      {/* Accessories Hero */}
      <AccHero />

      {/* Accessories Category Circles */}
      <CategoryCircles
        loadAllProductsWithCategory={
          loadAllProductsWithCategory
        }
      />

      {/* Accessories Carousel */}
      <AccCaro />

      {/* Products */}
      <section className="home-products-section">
        <div className="home-products-container">

          <h2 className="home-products-title">
            Accessories
          </h2>

          {loading && (
            <div
              style={{
                textAlign: "center",
                padding: "30px",
              }}
            >
              Loading products...
            </div>
          )}

          {!loading &&
            allProducts.length > 0 && (
              <div className="home-products-grid">

                {allProducts.map((product) => {
                  const formattedProduct =
                    formatProduct(product);

                  return (
                    <ProductCard
                      key={product.id}
                      product={formattedProduct}
                      type={formattedProduct.type}

                      wishlist={wishlist}
                      toggleWishlist={toggleWishlist}

                      cart={cart}
                      toggleCart={toggleCart}

                      onCardClick={() =>
                        navigate(
                          `/product-detail/${product.id}`
                        )
                      }
                    />
                  );
                })}

              </div>
            )}

          {!loading &&
            allProducts.length === 0 && (
              <p
                style={{
                  textAlign: "center",
                  color: "#999",
                  padding: "40px",
                }}
              >
                No products found.
              </p>
            )}

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Accessories;